import {
  Connection,
  ConnectionDTO,
  ConnectionUpdateDTO,
  FtpData,
  NetsuiteData,
  PaginatedConnectionsResponse,
  PostgresqlData,
  RestData,
  RestletData,
  SftpData,
} from '../interfaces/connection-interface';
import { map, OperatorFunction } from 'rxjs';

export function mapPaginationToData(): OperatorFunction<
  PaginatedConnectionsResponse,
  Connection[]
> {
  return map((response) => response.data);
}

export function mapConnectionToUpdateDTO(
  connection: Connection,
  formValues: PostgresqlData | FtpData | SftpData | RestData | RestletData | NetsuiteData
): ConnectionUpdateDTO {
  return {
    id: connection.id,
    owner: connection.owner,
    type: connection.type,
    config: { ...formValues },
    is_active: connection.is_active,
  } as ConnectionUpdateDTO;
}

export function mapConnectionToDTO(
  connection: Connection,
  formValues: PostgresqlData | FtpData | SftpData | RestData | RestletData | NetsuiteData
): ConnectionDTO {
  const connectionName =
    connection.type === 'ftp' || connection.type === 'sftp' || connection.type === 'netsuite'
      ? (formValues as FtpData | SftpData | NetsuiteData).name
      : connection.name;

  return {
    name: connectionName,
    type: connection.type,
    owner: connection.owner,
    config: formValues,
  } as ConnectionDTO;
}
